import React, { useEffect, useState } from "react";
import { Card, DropdownMenu, DropdownToggle, DropdownItem, UncontrolledDropdown } from "reactstrap";
import { productData, productDataSet2, productDataSet3, productDataSet4 } from "./ProductData";
import MyLoader from "../../../../MyComp/UI/form/MyLoader";
import { BASE_URL_IMG, RUPEES_SYMBOL } from "../../../../assets/constants";

const TopProducts = ({ data, filter, setFilter, isLoading }) => {
  const returnTotal = (n1, n2) => {
    var result = n1 * Number(n2);
    return result.toFixed(2);
  };
  return (
    <Card className="h-100">
      <div className="card-inner">
        <div className="card-title-group mb-2">
          <div className="card-title">
            <h6 className="title">Top products</h6>
          </div>
          <div className="card-tools">
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                href="#toggle"
                onClick={(ev) => ev.preventDefault()}
                className="link link-light link-sm dropdown-indicator"
              >
                {filter}
              </DropdownToggle>
              <DropdownMenu end className="dropdown-menu-sm">
                <ul className="link-list-opt no-bdr">
                  <li className={filter === "Daily" ? "active" : ""}>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setFilter("Daily");
                      }}
                    >
                      <span>Daily</span>
                    </DropdownItem>
                  </li>
                  <li className={filter === "Weekly" ? "active" : ""}>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setFilter("Weekly");
                      }}
                    >
                      <span>Weekly</span>
                    </DropdownItem>
                  </li>
                  <li className={filter === "Monthly" ? "active" : ""}>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setFilter("Monthly");
                      }}
                    >
                      <span>Monthly</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
        <ul className="nk-top-products">
          {isLoading ? (
            <MyLoader />
          ) : (
            <>
              {data.map((item, idx) => (
                <li className="item" key={idx}>
                  <div className="thumb">
                    <img src={BASE_URL_IMG + item?.product_banner_image} alt={item?.product_name} />
                  </div>
                  <div className="info">
                    <div className="title">{item.product_name}</div>
                    <div className="price">{RUPEES_SYMBOL}{item?.final_price}</div>
                  </div>
                  <div className="total">
                    <div className="amount">{RUPEES_SYMBOL}{returnTotal(item.final_price, item?.sold)}</div>
                    <div className="count">{item.sold} Sold</div>
                  </div>
                </li>
              ))}
            </>
          )}
        </ul>
      </div>
    </Card>
  );
};

export default TopProducts;
